module.exports = __webpack_public_path__ + "img/DVR4.33fcbc0d.png";